<template>
  <div>
    <form
      ref="formpayment"
      method="post"
      action="https://www.thaiepay.com/epaylink/payment.aspx"
    >
      <input type="hidden" name="merchantid" :value="query.merchantid" />
      <input type="hidden" name="refno" :value="refno" />
      <input type="hidden" name="customeremail" :value="query.customeremail" />
      <input type="hidden" name="productdetail" :value="query.productdetail" />
      <input type="hidden" name="total" :value="query.total" />
      <input type="hidden" name="cc" value="00" />
      <input type="hidden" name="lang" value="TH" />
      <input
        v-if="query.apptype == 'line'"
        type="hidden"
        name="returnurl"
        value="https://line.me/R/ti/p/@phb5809t"
      />
      <input
        v-else-if="query.apptype == 'facebook'"
        type="hidden"
        name="returnurl"
        value="https://www.facebook.com"
      />
      <input
        type="hidden"
        name="postbackurl"
        :value="`https://communitybotbyzwizai.herokuapp.com/paysolutionscompletedtoa?refno=${refno}`"
      />
      <br />
      <input type="hidden" name="Submit" value="Confirm Order" />
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  data() {
    return {
      refno: "",
    };
  },
  async mounted() {
    await this.updatepaysolution();
  },
  methods: {
    updatepaysolution() {
      var vm = this;
      return new Promise((resolve) => {
        var data = {
          refno: this.query.refno,
          userid: this.$store.state.userid,
          apptype: this.query.apptype,
          pageid: this.query.pageid,
        };
        axios
          .put(
            "https://communitybotbyzwizai.herokuapp.com/toapaysolutionupdaterefno",
            data,
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await this.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              return;
            } else if (response.data.responsecode == 200) {
              vm.refno = response.data.data[0].refno;
              vm.$nextTick(() => {
                vm.$refs.formpayment.submit();
              });
            } else {
              await vm.$swal.fire({
                text: response.data.reason,
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
            }
            resolve();
          });
      });
    },
  },
};
</script>

